import { render, staticRenderFns } from "./AddBankScreen.vue?vue&type=template&id=539cadfc&scoped=true&"
import script from "./AddBankScreen.vue?vue&type=script&lang=js&"
export * from "./AddBankScreen.vue?vue&type=script&lang=js&"
import style0 from "./AddBankScreen.vue?vue&type=style&index=0&id=539cadfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539cadfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539cadfc')) {
      api.createRecord('539cadfc', component.options)
    } else {
      api.reload('539cadfc', component.options)
    }
    module.hot.accept("./AddBankScreen.vue?vue&type=template&id=539cadfc&scoped=true&", function () {
      api.rerender('539cadfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/screens/AddBankScreen.vue"
export default component.exports